<template>
  <b-card
    class="cardStyle"
    header-class="text-black"
    style="height: 100%; font-weight: 400; font-size: 18px; line-height: 27px"
    sub-title="If you have a technical issue or question regarding the use of My Pfizer Studies, please select the issue type and click submit. The My Pfizer Studies Support Team will reach out to you within 24 hours. Note: If you have a study-related or data question, please reach out to your Pfizer point of contact or site monitor."
    title="Contact Us"
  >
    <hr class="solid" />
    <validation-observer ref="observer">
      <b-form-group>
        <label class="mb-0 h6" for="title"
          >Select the issue type<span class="requiredStar"> * </span></label
        >
        <validation-provider ref="provider" v-slot="validationContext" rules="required">
          <b-form-select
            id="title"
            v-model="form.title"
            :state="getValidationState(validationContext)"
            :options="options"
            class="rounded-pill"
          ></b-form-select>
          <b-form-invalid-feedback id="validationFeedback"
            >{{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </b-form-group>
    </validation-observer>
    <div class="text-right">
      <b-button class="px-4" pill variant="primary" @click="submit()"> Submit</b-button>
    </div>
    <saving-modal
      id="ticketCreationModal"
      :busy="busy"
      :errorMessage="'Please try again later or contact support via email.'"
      :modalLoading="modalLoading"
      :modalSuccessMessage="'Thank you for submitting this support ticket.'"
      :modalTitle="modalTitle"
      :saveResponseStatus="saveResponseStatus"
      @handleOk="savingModalOk()"
    ></saving-modal>
  </b-card>
</template>
<script>
  import SavingModal from '../utility/SavingModal';

  export default {
    name: 'contact-support',
    props: {
      helpTopicTitle: { type: String },
    },
    components: {
      SavingModal,
    },
    data() {
      return {
        form: {
          context: '',
          title: '',
          name: `${window.Laravel.user_firstName} ${window.Laravel.user_lastName}`,
          email: window.Laravel.user_email,
          phone: '',
          body: '',
        },
        modalLoading: false,
        modalTitle: '',
        busy: false,
        saveResponseStatus: null,
        options: [
          { value: 'Access Issue', text: 'Access Issue' },
          { value: 'Technical Issue', text: 'Technical Issue' },
          { value: 'Information/How To', text: 'Information/How To' },
          { value: 'Other', text: 'Other' },
        ],
      };
    },
    watch: {
      helpTopicTitle(newValue) {
        this.form.context = newValue;
      },
    },
    methods: {
      getValidationState({ dirty, validated, valid = null, required }) {
        if (required) {
          return dirty || validated ? valid : null;
        }
      },
      async submit() {
        const isValid = await this.$refs.observer.validate();
        if (isValid) {
          await this.createTicket();
        }
      },
      async createTicket() {
        this.busy = true;
        this.modalTitle = 'Creating ticket...';
        this.modalLoading = true;
        this.$bvModal.show('ticketCreationModal');
        let errorMessage = '';
        try {
          let response = await axios.post(`/api/create-support-ticket`, this.form);
          this.saveResponseStatus = response.data['statuscode'];
        } catch (e) {
          this.saveResponseStatus = e.response.status;
          errorMessage = e.response.data.message;
          console.error(e);
        }
        if (this.saveResponseStatus == 200 || this.saveResponseStatus == 201) {
          this.modalTitle = 'Ticket Submitted';
        } else if (
          this.saveResponseStatus == 400 &&
          errorMessage === 'Support message is currently unavailable'
        ) {
          // NOTE faking a 200 response for testing ticket submissions when submission is disabled
          this.saveResponseStatus = 200;
          this.modalTitle = 'Ticket Submitted (Email service is currently disabled)';
        } else {
          this.modalTitle = 'Something went wrong!';
        }
        this.modalLoading = false;
        this.busy = false;
      },
      savingModalOk() {
        if (this.saveResponseStatus == 200 || this.saveResponseStatus == 201) {
          this.form = {
            title: null,
            name: `${window.Laravel.user_firstName} ${window.Laravel.user_lastName}`,
            email: window.Laravel.user_email,
            phone: null,
            body: null,
          };
          this.$refs.observer.reset();
        }
        this.$bvModal.hide('ticketCreationModal');
      },
    },
  };
</script>
<style>
  .textarea-style {
    background: rgb(255, 255, 255);
    border: 1px solid rgb(231, 224, 236);
    box-sizing: border-box;
    border-radius: 8px;
    height: 196px;
    padding: 1rem;
  }
</style>
